import React from 'react';

import './style.sass';
import { CampaignsColors } from 'app/utils/campaignStatusHelpers';

type Props = {
    textClassName?: string,
    text: string,
    indicatorColor: CampaignsColors,
};

export const StatusIndicator = ({
    textClassName = 'p1-medium',
    text,
    indicatorColor,
}: Props) => {
    return (
        <div className="status-indicator">
            <div className={`status-indicator__indicator status-indicator__indicator--${indicatorColor}`}></div>

            <span className={`status-indicator__text ${textClassName} dark-violet`}>{text}</span>
        </div>
    );
};
